import { Flex } from 'antd';
import { FC, ReactNode } from 'react';
import { Logo } from '@/components/logo';
import './index.scss';

// Class the layouts put on their antd Header at every breakpoint, which pins
// it to the top (styled in index.scss).
export const HEADER_SLOT_CLASS = 'header-slot';

// Added on top of HEADER_SLOT_CLASS once the page has scrolled, to show the
// header's shadow.
export const HEADER_SLOT_SCROLLED_CLASS = 'header-slot--scrolled';

interface Props {
  actions?: ReactNode;
}

// TCX-1122: the one mobile header every page gets. The left side is always the
// logo (tapping it goes to the landing page) and takes no prop, so no layout or
// page can swap it out; only the right side varies per layout. Its height is
// $mobile-header-height (styles/variables.scss), the same token chat.scss
// subtracts on mobile, and the actions are vertically centred inside it.
const MobileHeader: FC<Props> = ({ actions }) => (
  <Flex
    className={'mobile-header'}
    justify={'space-between'}
    align={'center'}
  >
    <Logo showText={false} />
    {actions && (
      <Flex align={'center'} gap={8}>
        {actions}
      </Flex>
    )}
  </Flex>
);

export { MobileHeader };
